import React, { ChangeEvent, useEffect, useRef } from "react";

import { IAppointmentRatingQuest } from "../../../services/appointment-rating/appointment-rating.interface";
import { TextField } from "@mui/material";

type IRatingCardProps = {
  value: string | null;
  handleRatingChange: (value: any) => void;
  question: IAppointmentRatingQuest;
  };

const VisitFeedback1 = (props: IRatingCardProps) => {
  const { value, handleRatingChange, question } = props;

  const handleChange = (e: ChangeEvent, feedbackValue: string) => {
    handleRatingChange(feedbackValue);
  };

  const textFieldRef = useRef<HTMLInputElement>(null);

  useEffect(() => {
    if (textFieldRef.current) {
      textFieldRef.current.focus();
    }
  }, []);

  return (

    <div className="flex flex-col items-start self-stretch gap-3 p-4 rounded-lg bg-white
            border border-taupe-50">
      {/* head */}
      <div className="flex flex-col gap-[2px] items-start">
        <h3 className="text-base font-bold leading-5">{question?.question}</h3>
        <h3 className="text-sm leading-5">
          {question?.subText}</h3>
      </div>
      {/* head end */}

      <TextField id="outlined-multiline-static"
        inputRef={textFieldRef}
        multiline
        minRows={4}
        maxRows={15}
        fullWidth
        value={value}
        onChange={(event)=>handleChange(event, event.target.value)}
        placeholder="Let us know your thoughts here"/>

    </div>
  );
};

export default VisitFeedback1;
